export type HostKind = 'owner' | 'co_host';

export interface HostListItem {
  community_user_id: number;
  member_id: number;
  name: string;
  avatar?: string | null;
  kind: HostKind;
  since?: string | null;
  is_self: boolean;
  can_remove: boolean;
  is_member: boolean;
}

export interface HostListStats {
  total_pengelola: number;
  co_host_aktif: number;
}

export interface HostListResponse {
  hosts: HostListItem[];
  stats: HostListStats;
}

export interface HostCandidate {
  community_user_id: number;
  member_id: number;
  name: string;
  avatar?: string | null;
  position: string;
  position_label: string;
  join_date: string;
}

export interface HostCandidateMeta {
  page: number;
  limit: number;
  total: number;
  total_pages: number;
}

export interface HostCandidateListResponse {
  items: HostCandidate[];
  meta: HostCandidateMeta;
}

export interface HostProfile {
  community_user_id: number;
  member_id: number;
  name: string;
  email: string;
  phone?: string | null;
  avatar?: string | null;
  nickname: string;
  position: string;
  join_date: string;
  co_host_granted_at?: string | null;
}

export interface CoHostCommunity {
  community_id: number;
  name: string;
  slug: string;
  logo: string;
  sport_category_name: string;
}

export interface CommunityMemberDetail {
  id: number;
  community_id: number;
  community_user_id: number;
  name: string;
  nickname: string;
  username: string;
  email: string;
  phone?: string | null;
  avatar?: string | null;
  join_date: string;
  event_count: number;
  keaktifan_percentage: number;
  win_rate: number;
  last_event_name?: string | null;
  last_event_date?: string | null;
}

export const communityHostKeys = {
  list: ['community-hosts'] as const,
  candidates: (search: string) => ['community-host-candidates', search] as const,
  communities: ['co-host-communities'] as const,
  memberDetail: (slug: string, memberId: number) =>
    ['community-host-member-detail', slug, memberId] as const,
};
